import React, { useState } from "react";
import { SendIcon } from "../icons";

const Input: React.FC<{ onSend: Function; isResponseLoading: boolean }> = ({
  onSend,
  isResponseLoading,
}) => {
  const [text, setText] = useState("");
  const [isSendDisabled, setIsSendDisabled] = useState(true);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setText(e?.target?.value);

    if (e?.target?.value?.trim() === "") {
      setIsSendDisabled(true);
    } else {
      setIsSendDisabled(false);
    }
  };

  const handleSend = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSend(text);
    setText("");
    setIsSendDisabled(true);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && (isSendDisabled || isResponseLoading)) {
      e.preventDefault();
    }
  };

  return (
    <div className="input">
      <form onSubmit={handleSend}>
        <input
          type="text"
          onChange={handleInputChange}
          value={text}
          placeholder="Ask me anything..."
          onKeyDown={handleKeyDown}
        />
        <button disabled={isSendDisabled || isResponseLoading}>
          <div className="icon">
            <SendIcon />
          </div>
        </button>
      </form>
    </div>
  );
};

export default Input;
